import { useSelector } from 'rahtab-redux';
import { orderingMerchandiseSelector } from 'rahtab-redux/slices/merchandiseOrderingSlice';

export default function useOrderingMerchandise(id: string) {
  const data = useSelector(orderingMerchandiseSelector(id));

  return { called: true, loading: false, data };
}
